export const parseQueryParameters = () => {
    let queryString = window.location.search || "";
    if (queryString !== "") {
        sessionStorage.setItem("queryString", queryString);
    }
    const urlParams = new URLSearchParams(window.location.search);
    console.log("Parsing query params: " + window.location.search)

    let journal = urlParams.get("journal") || "";
    if (journal !== "") {
        sessionStorage.setItem("journal", journal);
    }
    let languageCode = urlParams.get("languageCode") || "";
    if (languageCode !== "") {
        sessionStorage.setItem("languageCode", languageCode);
    }
    let peopleIdentifier = urlParams.get("peopleIdentifier") || "";
    if (peopleIdentifier !== "") {
        sessionStorage.setItem("peopleIdentifier", peopleIdentifier);
    }
    let role = urlParams.get("role") || "";
    if (role !== "") {
        sessionStorage.setItem("role", role);
    }
    let questionnaireId = urlParams.get("questionnaireId") || "";
    if (questionnaireId !== "") {
        sessionStorage.setItem("questionnaireId", questionnaireId);
    }
}